
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/landings/[landingPage]",
      function () {
        return require("private-next-pages/landings/[landingPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/landings/[landingPage]"])
      });
    }
  